type SvrBillingForManualPayment = {
  invoiceStatus?: string | null;
};

/**
 * Finance may record a verified historical/prepaid payment before an SVR invoice
 * PDF is generated. The billing row is the authority; an invoice artifact is not.
 */
export function canRecordSvrManualPayment(
  billing: SvrBillingForManualPayment | null | undefined,
): boolean {
  if (!billing) return false;
  const status = String(billing.invoiceStatus ?? "").trim().toLowerCase();
  return status !== "paid" && status !== "waived";
}
